import * as React from "react"

function ModalidadIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.53 17" {...props}>
      <defs>
        <style>{".cls-1{fill:#003da6}"}</style>
      </defs>
      <g id="Capa_2" data-name="Capa 2">
        <g id="Capa_1-2" data-name="Capa 1">
          <path
            className="cls-1"
            d="M13.68 13.48a1.42 1.42 0 01-1.09.5h-1.9V13h1.21l-.54-1.32a4.54 4.54 0 001.26-3.18A4.42 4.42 0 008.26 4a4.42 4.42 0 00-4.35 4.5 4.54 4.54 0 001.26 3.16L4.63 13h1.21v1h-1.9a1.46 1.46 0 01-1.09-.5 7.58 7.58 0 01.57-10.6 7.1 7.1 0 015.71-1.85 7.45 7.45 0 016.36 6.36 7.67 7.67 0 01-1.81 6.07M12.62 16h-1.93v-1h1.93zm-4.84 0h-1v-3h1zm2.7-6.49a2.64 2.64 0 00.21-1 2.43 2.43 0 10-4.85 0 2.64 2.64 0 00.21 1l-.46 1.13a3.55 3.55 0 01-.71-2.14A3.45 3.45 0 018.26 5a3.45 3.45 0 013.39 3.5 3.55 3.55 0 01-.71 2.14zm-3.67-1a1.46 1.46 0 112.91 0 1.43 1.43 0 01-.09.5H6.9a1.43 1.43 0 01-.09-.5M6.09 12l.82-2h2.71l.82 2zm3.63 4h-1v-3h1zm-5.81-1h1.93v1H3.91zm12.54-7.7A8.44 8.44 0 009.24.06a8.08 8.08 0 00-6.47 2.1 8.6 8.6 0 00-.65 12 2.44 2.44 0 00.82.61V17h10.65v-2.25a2.31 2.31 0 00.81-.61A8.54 8.54 0 0016.14 11a8.67 8.67 0 00.31-3.76"
          />
          <path className="cls-1" d="M1.97 7.01H2.94V8H1.97z" />
          <path className="cls-1" d="M1.97 9H2.94V10H1.97z" />
          <path className="cls-1" d="M13.59 7.01H14.56V8H13.59z" />
          <path className="cls-1" d="M13.59 9H14.56V10H13.59z" />
          <path className="cls-1" d="M6.81 2.02H9.719999999999999V3.02H6.81z" />
        </g>
      </g>
    </svg>
  )
}

export default ModalidadIcon
